import { normalizeVenueId } from './venueParam';

export const hasVenueParameter = search => ['venue_id', 'venue', 'venueId', 'id']
  .some(key => new URLSearchParams(search).has(key));

export const getLegacyLinkTarget = pathname => {
  const match = pathname.match(/^\/(?:service|discover)\/(?:detail|list)\/([^/]+)\/?$/)
    || pathname.match(/^\/article\/([^/]+)\/?$/);
  if (!match) return null;
  try {
    const id = normalizeVenueId(decodeURIComponent(match[1]));
    return id ? { kind: pathname.startsWith('/article/') ? 'article' : 'content', id } : null;
  } catch { return null; }
};

export const readLegacyVenue = () => {
  try { return normalizeVenueId(localStorage.getItem('venue_id')); }
  catch { return ''; }
};
